// @flow

import style from "./style.module.scss";

import React, { type Element } from "react";
import { Container } from "reactstrap";
import { NoResults } from "@components";
import { type PageContentProps } from "../PageContent";

type Props = {
    headerProps: $Diff<PageContentProps, { children: * }>,
    filter: Element<*>,
    map: Element<*>,
    results: React$Element<*>,
    showMapByDefault?: boolean,
    mapVisible: boolean,
    containsAgencyFilter: boolean,
    RenderSearchResultsHeader: Element<*>,
    RenderSearchPageBanner: Element<*>,
    pageTitle?: string,
    isLoading: boolean,
};

const SearchContainer = ({
    map,
    results,
    mapVisible,
    RenderSearchResultsHeader,
    pageTitle,
    isLoading,
}: Props) => {
    return (
        <>
            {mapVisible ? (
                <>
                    <Container fluid={true}>
                        {pageTitle && (
                            <h1 className={style.pageTitle}>{pageTitle}</h1>
                        )}
                    </Container>
                    <Container
                        fluid={true}
                        className={style.searchResultsWrapper}
                    >
                        <div className={style.map}>
                            <div className={style.searchResultsHeader}>
                                <RenderSearchResultsHeader />
                            </div>
                            {map}
                        </div>
                        <div className={style.results}>{results}</div>
                    </Container>
                </>
            ) : (
                <>
                    {results.props.numberOfResults === 0 &&
                        isLoading === false &&
                        results.props.numberOfResults !== undefined && (
                            <NoResults />
                        )}
                    {!isLoading && (
                        <Container>
                            {pageTitle && (
                                <h1 className={style.pageTitle}>{pageTitle}</h1>
                            )}
                            {React.cloneElement(results, {
                                Header: (
                                    <div
                                        className={
                                            style.noMapSearchResultsHeader
                                        }
                                    >
                                        <RenderSearchResultsHeader />
                                        {results.props.Header}
                                    </div>
                                ),
                            })}
                        </Container>
                    )}
                </>
            )}
        </>
    );
};

export default SearchContainer;
